import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';

function ASNTable(props) {

    const columns = [
        {
            field: 'Sku',
            headerName: 'SKU',
            flex: 1,
            minWidth: 50,
            editable: false
        },
        {
            field: 'Description',
            headerName: 'Description',
            flex: 1,
            minWidth: 100,
            editable: false
        }, 
        {
            field: 'OrderedQty',
            headerName: 'Qty Ordered',
            flex: 1,
            minWidth: 50,
            editable: false
        }, 
        {
            field: 'Qty',
            headerName: 'Qty Shipped',
            flex: 1,
            minWidth: 50,
            editable: false
        }, 
    ];

    return(
        <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
            <DataGrid
                className = {props.isMobile ? "mobile-table" : "desktop-table"}
                sx = {{ 
                    height: "500px",
                }}
                rows = {props.items}
                getRowId = {(row) => row.id}
                columns = {columns}
                rowsPerPageOptions = {[25, 50, 100]}
                checkboxSelection = {false}
            />
            <Button onClick = {props.sendASN} sx = {{ ml: '10px', mt: '10px' }} disabled = {props.loading} variant = "contained" color = "primary">
                Send ASN to {(props.warehouse_options.find(option => option.value === props.warehouse))?.name} 
            </Button>
        </Box>
    );
};

export default ASNTable;